import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BuddyLogo } from "../components/Brand";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen adult-bg flex flex-col">
      <header className="p-6"><Link to="/"><BuddyLogo /></Link></header>
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="hb-card p-10 max-w-md w-full text-center">
          <h1 className="font-adult font-bold text-3xl text-slate-900">{t("payments.cancelled")}</h1>
          <p className="text-slate-600 mt-2">{t("payments.cancelledBody")}</p>
          <div className="mt-6 flex justify-center gap-2">
            <Link to="/pricing"><Button className="bg-slate-900 hover:bg-slate-800 text-white rounded-full">{t("payments.backToPlans")}</Button></Link>
          </div>
        </div>
      </main>
    </div>
  );
}
